module.exports = __webpack_public_path__ + "media/award.503385c3.mp3";